<p-dialog
  [(visible)]="showPopupPayment"
  [style]="{ width: '450px' }"
  [modal]="true"
  [resizable]="false"
  [closable]="false"
  [closeOnEscape]="true"
  [draggable]="false">
  <div *ngIf="!paymentSuccess; else paymentSuccessPopup">
    <h1 class="font-bold white-space-nowrap text-lg">
      {{ "paymentFormPopup.titleError" | translate }}
    </h1>
    <div class="flex flex-col">
      <p class="font-app-regular mt-4">
        {{ "paymentFormPopup.textError1" | translate }}
      </p>
      <p class="font-app-regular">
        {{ "paymentFormPopup.textError2" | translate }}
      </p>
    </div>
  </div>
  <ng-template #paymentSuccessPopup>
    <div>
      <h1 class="font-bold white-space-nowrap text-lg">
        @if (unpaidPolicy) {
          {{ "paymentFormPopup.titleSuccess" | translate }}
        }
        @if (advancePayment) {
          {{ "paymentFormPopup.titleSuccess1" | translate }}
        }
      </h1>
      <p class="font-app-regular mt-4">
        @if (unpaidPolicy) {
          {{ "paymentFormPopup.textSuccess1" | translate }}
        }
        @if (advancePayment) {
          {{ "paymentFormPopup.textSuccess4" | translate }}
        }
      </p>
      <br />
      <p class="font-app-regular">
        @if (unpaidPolicy) {
          {{ "paymentFormPopup.textSuccess2" | translate }}
        }
        @if (advancePayment) {
          {{ "paymentFormPopup.textSuccess5" | translate }}
        }
      </p>
      <br />
      @if (unpaidPolicy) {
        <p class="font-app-regular">
          {{ "paymentFormPopup.textSuccess3" | translate }}
        </p>
      }
    </div>
  </ng-template>
  <div class="popup-button py-4">
    <button
      class="rounded-md py-3 px-5 border-primary border-solid border-2 bg-primary text-white text-center w-60"
      (click)="close()">
      {{ "paymentFormPopup.textButton" | translate }}
    </button>
  </div>
</p-dialog>

